import { render, staticRenderFns } from "./DirTargets.vue?vue&type=template&id=0cbe9f0b&scoped=true&"
import script from "./DirTargets.vue?vue&type=script&lang=js&"
export * from "./DirTargets.vue?vue&type=script&lang=js&"
import style0 from "./DirTargets.vue?vue&type=style&index=0&id=0cbe9f0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbe9f0b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
